const VALID_TOKEN_ORIGINS = [
  'https://signin.cj.com/',
  'https://staging-signin.cj.com/',
]

export const UnblockRoute = (props) => {
  const params = new URLSearchParams(props.location.search)
  const rawToken = params.get('token')
  const brand = params.get('brand')

  if (!rawToken) {
    window.location.href = 'https://signin.cj.com'
    return null
  }

  let decodedToken
  try {
    decodedToken = decodeURIComponent(rawToken)
  } catch {
    window.location.href = 'https://signin.cj.com'
    return null
  }

  if (!VALID_TOKEN_ORIGINS.some(origin => decodedToken.startsWith(origin))) {
    window.location.href = 'https://signin.cj.com'
    return null
  }

  if (brand === 'booking') {
    sessionStorage.setItem('brand', brand)
  }

  window.location.href = decodedToken
  return null
}

export default UnblockRoute
